<div class="flex h-screen bg-primary-50 overflow-hidden">
  <!-- Left: Background Image Section -->
  <div
    class="hidden lg:block lg:w-1/2 relative overflow-hidden h-full"
  >
    <div
      class="absolute inset-0 w-full h-full bg-center bg-no-repeat bg-cover"
      [style.background-image]="'url(assets/IMG-20260406-WA0000.jpg)'"
    ></div>
  </div>

  <!-- Right: Login Section -->
  <div class="w-full lg:w-1/2 flex flex-col items-center justify-center p-8 lg:p-16 h-full">
    <div class="w-full max-w-md flex flex-col items-center">
      <!-- Logo -->
      <div class="mb-8">
        <div class="w-30 h-30">
          <img
            src="assets/apple-touch-icon.png"
            alt="HP SDRF Logo"
            class="w-full h-full object-contain"
          />
        </div>
      </div>

      <!-- Titles -->
      <div class="text-center mb-10">
        <h1 class="text-3xl font-bold text-gray-800 mb-2 tracking-tight">
          SDRF Inventory Management System
        </h1>
        <p class="text-gray-600 text-lg mb-4">
          Secure access for disaster operations & resource tracking
        </p>
        <div class="flex items-center justify-center gap-2 text-orange-500 font-bold tracking-widest text-sm">
          <span>PREPARED</span>
          <span class="text-gray-300">•</span>
          <span>RESPONSIVE</span>
          <span class="text-gray-300">•</span>
          <span>RELIABLE</span>
        </div>
      </div>

      <!-- Sign In Card -->
      <div class="w-full bg-white rounded-3xl shadow-xl p-8 lg:p-10 border border-white/50">
        <h2 class="text-2xl font-bold text-gray-800 mb-2">Sign In</h2>
        <p class="text-gray-500 mb-8">
          Welcome! Please sign in using your official credentials
        </p>

        <!-- SSO Login Button using PrimeNG -->
        <p-button
          (onClick)="loginWithOAuth()"
          label="Continue With Single Sign On"
          icon="pi pi-shield-check"
          styleClass="w-full py-4 px-6 rounded-xl font-semibold border-none"
          [loading]="isLoading"
        ></p-button>

        <div class="mt-8 pt-8 border-t border-gray-100">
          <div class="flex items-start gap-3 text-gray-400 text-sm leading-relaxed">
            <i class="pi pi-lock mt-1 flex-shrink-0" style="font-size: 1rem"></i>
            <p>
              You will be redirected to the official government portal to securely sign in.
            </p>
          </div>
        </div>

        <div class="mt-10 flex items-center justify-center gap-4 text-gray-400 text-xs font-medium">
          <a>Help</a>
          <span class="w-1 h-1 bg-gray-200 rounded-full"></span>
          <a>Terms of Service</a>
          <span class="w-1 h-1 bg-gray-200 rounded-full"></span>
          <a>Privacy Policy</a>
        </div>
      </div>

      <!-- Footer -->
      <p class="mt-12 text-gray-400 text-xs text-center">
        © 2023 State Disaster Recovery Force. All Rights Reserved.
      </p>
    </div>
  </div>
</div>
